(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_bar-chart"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-bar-chart-toggle]');
    if (!btn) return;
    var barChart = btn.closest('.bar-chart');
    if (!barChart) return;
    var isOpen = barChart.classList.toggle('bar-chart--show-details');
    btn.setAttribute('aria-expanded', String(isOpen));
    var labelShow = btn.querySelector('[data-toggle-label-show]');
    var labelHide = btn.querySelector('[data-toggle-label-hide]');
    if (labelShow) labelShow.hidden = isOpen;
    if (labelHide) labelHide.hidden = !isOpen;
  });
  } catch(e) { console.error(e); }
})();

})();
